import { Box, forwardRef, Icon, Tooltip } from '@chakra-ui/react'
import React from 'react'

export const leftIconSize = '1.375rem'

const InputLeftIcon = ({ icon, title, ...props }) => (
  <Box pt="2" {...props}>
    <Tooltip label={title}>
      <span>
        <Icon width={leftIconSize} height={leftIconSize} color="teal.600" as={icon} />
      </span>
    </Tooltip>
  </Box>
)

export default InputLeftIcon
